import { _firestore } from '@/lib/db';

export const GetFirestoreUser = ( uid, cb = null ) => {

	if ( !cb ) {
		return _firestore
		 .collection( 'users' )
		 .doc( uid )
		 .get()
		 .then( doc => doc.data() );
	}

	return _firestore
		.collection( 'users' )
		.doc( uid )
		.onSnapshot( ( docSnapshot ) => {
			if ( !docSnapshot.exists ) {
				return cb( null );
			}

			return cb( docSnapshot.data() );
		} );

};

export const GetUsers = callback => _firestore
	.collection( 'users' )
	.onSnapshot( ( querySnapshot ) => {
		const users = [];

		querySnapshot.forEach( ( doc ) => {
			users.push( doc.data() );
		} );

		callback( users );
	} );

export const SetFirestoreUser = ( user, uid ) => _firestore
	.collection( 'users' )
	.doc( uid )
	.set( user );
